import * as React from 'react'

function SvgSydAirportLogo(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>,
) {
  return (
    <svg
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 232.34 90.77"
      ref={svgRef}
      {...props}
    >
      <defs>
        <linearGradient
          id="SYD-Airport-logo_svg__a"
          x1={-1.77}
          y1={45.39}
          x2={230.39}
          y2={45.39}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopOpacity={0.3} />
          <stop offset={0.9} />
        </linearGradient>
        <linearGradient
          id="SYD-Airport-logo_svg__b"
          x1={-1.77}
          y1={45.39}
          x2={230.39}
          y2={45.39}
          xlinkHref="#SYD-Airport-logo_svg__a"
        />
        <linearGradient
          id="SYD-Airport-logo_svg__c"
          x1={-1.77}
          y1={45.39}
          x2={230.39}
          y2={45.39}
          xlinkHref="#SYD-Airport-logo_svg__a"
        />
      </defs>
      <path
        d="M72.61 27.49C71.07 12.27 58.3 0 35.29 0 16.24 0 1.41 10.87 1.41 26.08c0 12.27 8.43 20.58 24.42 24.29l13.68 3.2c11.37 2.68 17 5.5 17 11.63 0 7-7.54 11-17.13 11-11.38 0-19.82-7.29-20.84-17.77H0c1.66 15.21 15 32.34 38.61 32.34 19.94 0 36.05-10.87 36.05-27 0-12.52-7.8-22.11-24.8-26.07l-13.68-3.2c-11.5-2.69-16.36-4.6-16.36-10 0-6.14 6.64-10 15.47-10 7.16 0 16.87 2.42 18 12.91z"
        fill="url(#SYD-Airport-logo_svg__a)"
      />
      <path
        fill="url(#SYD-Airport-logo_svg__b)"
        d="M119.28 50.24l32.6-48.96h-20.33l-21.22 31.96L88.98 1.28H68.65l32.73 49.22v38.99h17.9V50.24z"
      />
      <path
        d="M213.94 45.39c0 17.64-9.59 29.53-27.49 29.53h-10.74V15.85h10.74c17.9 0 27.49 11.89 27.49 29.54m18.41 0c0-28.64-18.16-44.11-46.67-44.11h-27.87v88.21h27.36c28.51 0 47.18-15.47 47.18-44.1"
        fill="url(#SYD-Airport-logo_svg__c)"
      />
    </svg>
  )
}

const ForwardRef = React.forwardRef(SvgSydAirportLogo)
export default ForwardRef
